<template>
  <el-container v-title data-title="订单记录" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>财务管理</el-breadcrumb-item>
                <el-breadcrumb-item>订单记录</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="类型">
                  <el-select v-model="searchForm.type" placeholder="类型">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="年费" value="1"></el-option>
                    <el-option label="补卡" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="状态">
                  <el-select v-model="searchForm.status" placeholder="状态">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="支付成功" value="2"></el-option>
                    <el-option label="支付失败" value="3"></el-option>
                    <el-option label="已退款" value="4"></el-option>
                    <el-option label="已处理" value="5"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="支付者用户名">
                  <el-input v-model="searchForm.payerUserName" placeholder="支付者用户名"></el-input>
                </el-form-item>
                <el-form-item label="学生姓名">
                  <el-input v-model="searchForm.studentRealName" placeholder="学生姓名"></el-input>
                </el-form-item>
                <el-form-item label="每页条数">
                  <el-select v-model="pageSize" @change="handleSizeChange" style="width:80px">
                    <el-option v-for="(item, index) in pageSizes" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getOrderList">查询</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="id" label="订单编号" width="310"></el-table-column>
          <el-table-column prop="payerUserName" label="支付者用户名" width="140"></el-table-column>
          <el-table-column prop="studentRealName" label="学生姓名" width="100"></el-table-column>
          <el-table-column prop="schoolName" label="学校" width="110"></el-table-column>
          <el-table-column prop="className" label="班级" width="80"></el-table-column>
          <el-table-column prop="typeName" label="订单类型" width="80"></el-table-column>
          <el-table-column prop="amount" label="订单金额" width="80" :formatter="formatYuan"></el-table-column>
          <el-table-column prop="wechatPayNo" label="微信支付单号" width="250"></el-table-column>
          <el-table-column prop="insertTime" label="生成时间" width="170"></el-table-column>
          <el-table-column prop="statusName" label="状态" width="80"></el-table-column>
          <el-table-column prop="remark" label="备注" width="150"></el-table-column>
          <el-table-column label="操作" width="125" v-if="userInfo.userType === '1'">
            <template slot-scope="scope">
              <el-button type="text" @click="openRefundDialog(scope.row)" v-if="['2', '5'].indexOf(scope.row.status) != -1">退款</el-button>
              <el-button type="text" @click="postRegainCard(scope.row)" v-if="scope.row.type === '2' && scope.row.status === '2'">已处理</el-button>
              <el-button type="text" @click="openRemarkDialog(scope.row)">备注</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="getOrderList"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :page-sizes="pageSizes"
            :total="total"
            layout="total,sizes,prev,pager,next" >
          </el-pagination>
        </div>
      </el-main>
      <!-- 弹窗页（退款） -->
      <el-dialog
        title="退款"
        :visible.sync="refundDialogVisible"
        width="420px"
        :before-close="handleClose">
        <el-form :model="refundForm" :rules="rules" label-width="90px">
          <el-form-item label="订单号" prop="orderNo">
            <el-input :disabled="true" v-model="refundForm.orderNo"></el-input>
          </el-form-item>
          <el-form-item label="退款金额" :required="true" prop="amount">
            <el-input type="number" v-model="refundForm.amount" style="width: 35%"></el-input> 元
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="refund()">退款</el-button>
            <el-button @click="refundDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 弹窗页（备注） -->
      <el-dialog
        title="备注"
        :visible.sync="remarkDialogVisible"
        width="420px"
        :before-close="handleClose">
        <el-form :model="remarkForm" :rules="rules" label-width="90px">
          <el-form-item label="订单号" prop="orderNo">
            <el-input :disabled="true" v-model="remarkForm.orderNo"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" :rows="4" placeholder="请输入备注内容" v-model="remarkForm.remark">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="remark()">确定</el-button>
            <el-button @click="remarkDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 15,
      pageSizes: [15, 50, 100, 150, 200, 300, 500, 1000, 2000],
      total: 0,
      searchForm: {
        type: '',
        status: ''
      },
      refundDialogVisible: false,
      refundForm: {},
      remarkDialogVisible: false,
      remarkForm: {},
      rules: {
        amount: [{ required: true, message: '请输入金额', trigger: 'blur' }]
      },
      schoolList: []
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getSchoolList()
      this.getOrderList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      done()
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.getOrderList()
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getOrderList () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/order/list',
        this.$qs.stringify({
          schoolId: _this.searchForm.schoolId,
          payerUserName: _this.searchForm.payerUserName,
          studentRealName: _this.searchForm.studentRealName,
          type: _this.searchForm.type,
          status: _this.searchForm.status,
          page: _this.currentPage,
          size: _this.pageSize
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.total = res.data.data.total
            _this.tableData = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    },
    openRefundDialog (orderData) {
      this.refundForm = {
        orderNo: orderData.id,
        amount: orderData.amount / 100
      }
      this.refundDialogVisible = true
    },
    refund () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/refund',
        this.$qs.stringify({
          orderNo: _this.refundForm.orderNo,
          amount: (_this.refundForm.amount * 100).toFixed(0)
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            this.$message({
              message: '退款成功',
              type: 'success'
            })
            _this.refundDialogVisible = false
            _this.refundForm = {}
            _this.getOrderList()
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    openRemarkDialog (orderData) {
      this.remarkForm = {
        orderNo: orderData.id,
        remark: orderData.remark
      }
      this.remarkDialogVisible = true
    },
    remark () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/order/remark',
        this.$qs.stringify({
          orderNo: _this.remarkForm.orderNo,
          remark: _this.remarkForm.remark
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            this.$message({
              message: '备注成功',
              type: 'success'
            })
            _this.remarkDialogVisible = false
            _this.remarkForm = {}
            _this.getOrderList()
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    postRegainCard (orderData) {
      let _this = this
      this.$confirm('确认已处理吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.GLOBAL.host + '/order/postRegainCard',
          this.$qs.stringify({
            id: orderData.id
          })
        ).then(res => {
          if (res.data != null) {
            if (res.data.status === 200) {
              this.$message({
                message: '已处理成功',
                type: 'success'
              })
              _this.getOrderList()
            } else {
              this.$message.error(res.data.message)
            }
          }
        })
      })
    },
    formatYuan: function (row, column) {
      return row.amount / 100
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/Order.vue